import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSessionStore } from '@entities/session';
import { ROUTES } from '@shared/config/routes';
import { FullscreenSpinner } from '@shared/ui';

export function RequireAuth({ children }: { children: ReactNode }) {
  const status = useSessionStore((s) => s.status);
  const location = useLocation();

  if (status === 'unknown') return <FullscreenSpinner />;
  if (status === 'anonymous') {
    return <Navigate to={ROUTES.login} replace state={{ from: location }} />;
  }
  return <>{children}</>;
}

export function RequireAnonymous({ children }: { children: ReactNode }) {
  const status = useSessionStore((s) => s.status);
  if (status === 'unknown') return <FullscreenSpinner />;
  if (status === 'authenticated') return <Navigate to={ROUTES.dashboard} replace />;
  return <>{children}</>;
}
